import { Injectable } from '@angular/core';
import { NgZone } from '@angular/core';
import {
  Observable,
  timer,
  Subject,
  BehaviorSubject,
  Subscription,
} from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable()
export class TimeService {
  private readonly initialTime = 0;

  private timer$: BehaviorSubject<number> = new BehaviorSubject(
    this.initialTime
  );
  private lastStopedTime: number = this.initialTime;
  private timerSubscription: Subscription = new Subscription();
  private isRunning = false;
  private timerStatus$: BehaviorSubject<boolean> = new BehaviorSubject(
    this.isRunning
  );
  constructor(private zone: NgZone) { }

  public get stopWatch$(): Observable<number> {
    return this.zone.runOutsideAngular(() => {
      return this.timer$.pipe(
      map((seconds: number): number => {return seconds;})
      );
    });
  }
  getTimerStatus(): Observable<boolean> {
    return this.timerStatus$.asObservable();
  }

  setTimerStatus(status: boolean): void {
    this.isRunning = status;
    this.timerStatus$.next(status);
  }

  startCount(): void {
    if (this.isRunning) {
      return;
    }
    this.timerSubscription = timer(0, 10) // Timer, so that the first emit is instantly (interval waits until the period is over for the first emit)
      .pipe(map((value: number): number => value + this.lastStopedTime))
      .subscribe(this.timer$); // each emit of the Observable will result in a emit of the BehaviorSubject timer$
    this.setTimerStatus(true);
  }

  stopTimer(): void {
    this.lastStopedTime = this.timer$.value;
    this.timerSubscription.unsubscribe();
    this.setTimerStatus(false);
  }

  resetTimer(): void {
    this.timerSubscription.unsubscribe();
    this.lastStopedTime = this.initialTime;
    this.timer$.next(this.initialTime);
    this.setTimerStatus(false);
  }
}
